// Роли пользователей по задаче в проекте

export const PROJECT_TASK_ROLE_VOLUNTEER = 'volunteer';